<div class="inner-current-balance">
  <div class="account-balance-label">{{ 'BALANCE' | transloco }}</div>
  <div class="account-balance-amount mt-4">
    <app-pre-loader class="mt-16" *ngIf="loading; else balanceLoaded"></app-pre-loader>
    <ng-template #balanceLoaded>
      <ion-button *ngIf="!hasProblem" color="secondary" class="refresh-balance-button" fill="clear" (click)="refreshAccountBalance($event)">
        <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
      </ion-button>
      <span *ngIf="!hasProblem; else problem"
        >{{ accountBalance! | translocoDecimal: { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}<span class="account-balance-devise">€</span>
      </span>
      <ng-template #problem>
        <div class="warning-color">
          <div class="error-title-container">
            <div class="reload-button-container">
              <ion-button *ngIf="hasProblem" color="secondary" class="refresh-balance-button" fill="clear" (click)="refreshAccountBalance($event)">
                <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
              </ion-button>
            </div>
            <div>NC</div>
            <div class="spacer"></div>
          </div>

          <div class="account-balance-error">{{ errorMessage || ('ERRORS.AnErrorOccured' | transloco) }}</div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
